import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-589718ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = { class: "layout" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Datos de Entrega", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "container" }
const _hoisted_8 = {
  class: "d-flex flex-column justify-content-center align-items-center w-100",
  style: {"height":"100%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-indicators" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-target": "#carouselExampleIndicators",
    "data-bs-slide-to": "0",
    class: "active",
    "aria-current": "true",
    "aria-label": "Slide 1"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-target": "#carouselExampleIndicators",
    "data-bs-slide-to": "1",
    "aria-label": "Slide 2"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-target": "#carouselExampleIndicators",
    "data-bs-slide-to": "2",
    "aria-label": "Slide 3"
  })
], -1))
const _hoisted_10 = { class: "carousel-inner w-100 h-100" }
const _hoisted_11 = { class: "carousel-item active h-100" }
const _hoisted_12 = { class: "d-flex justify-content-center align-items-center h-100" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-auto text-center" }
const _hoisted_15 = { class: "devices" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "col-auto text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Matrícula")
], -1))
const _hoisted_19 = { class: "btn-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-camera",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-arrow-repeat",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
  })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-circle",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" })
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2(Base64)h-11z" })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "carousel-item h-100" }
const _hoisted_29 = { class: "d-flex justify-content-center align-items-center h-100" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-auto text-center" }
const _hoisted_32 = { class: "devices" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "col-auto text-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cédula")
], -1))
const _hoisted_36 = { class: "btn-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-camera",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" })
], -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-arrow-repeat",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
  })
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-circle",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" })
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" })
], -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "carousel-item h-100" }
const _hoisted_46 = { class: "d-flex justify-content-center align-items-center h-100" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-auto text-center" }
const _hoisted_49 = {
  class: "border border-black-500",
  style: {"height":"250px","width":"500px"}
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Firma")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-check2-circle",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
], -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" })
], -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev custom-control\" type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide=\"prev\" data-v-589718ed><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-589718ed></span><span class=\"visually-hidden\" data-v-589718ed>Previous</span></button><button class=\"carousel-control-next custom-control\" type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide=\"next\" data-v-589718ed><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-589718ed></span><span class=\"visually-hidden\" data-v-589718ed>Next</span></button>", 2)

import { ref, onMounted, onUnmounted } from 'vue';
import { Carousel } from 'bootstrap';
import SignaturePad from 'signature_pad';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';
import { useDateTimeStore } from '@/store/dateTimeStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'InDatosE',
  props: {
    BdatosE: Boolean,
    numembarque: String
},
  emits: ['DEpropsValue'],
  setup(__props, { emit: __emit }) {

const { success, error, question, warning } = useAlert()
const dUrl = UrlGlobal()
const userStore = userGlobalStore()
const dateTimeStore = useDateTimeStore();

//props y emits
const props = __props
const emits = __emit
const handleClick = () => {
    
    emits("DEpropsValue", !props.BdatosE)
}

// Referencias para el carrusel y la firma
const carouselRef = ref<HTMLElement | null>(null);
const canvasRef = ref<HTMLCanvasElement | null>(null);
const firmaPad = ref<SignaturePad | null>(null);
const firmaBase64 = ref<string | null>(null);

// Variables para la cámara de Matrícula
const video1 = ref<HTMLVideoElement | null>(null);
const canvas1 = ref<HTMLCanvasElement | null>(null);
const photo1 = ref<string | null>(null);
const isCameraActive1 = ref(false);
let stream1: MediaStream | null = null;

// Variables para la cámara de Cédula
const video2 = ref<HTMLVideoElement | null>(null);
const canvas2 = ref<HTMLCanvasElement | null>(null);
const photo2 = ref<string | null>(null);
const isCameraActive2 = ref(false);
let stream2: MediaStream | null = null;

// Variables para manejar cámaras disponibles
const cameras = ref<MediaDeviceInfo[]>([]);
const currentCameraIndex1 = ref(0); // Índice para la cámara de Matrícula
const currentCameraIndex2 = ref(0); // Índice para la cámara de Cédula

// Listar cámaras disponibles
const listCameras = async () => {
    try {
        await navigator.mediaDevices.getUserMedia({ video: true }); // Solicitar permisos
        const devices = await navigator.mediaDevices.enumerateDevices();
        cameras.value = devices.filter(device => device.kind === 'videoinput');
        if (cameras.value.length > 0) {
            currentCameraIndex1.value = 0; // Cámara por defecto para Matrícula
            currentCameraIndex2.value = 0; // Cámara por defecto para Cédula
        }
    } catch (error) {
        console.error('Error al obtener las cámaras:', error);
        alert('No se pudieron listar las cámaras. Asegúrate de conceder permisos.');
    }
};

// Iniciar cámara
const startCamera = async (camNumber: number) => {
    const video = camNumber === 1 ? video1 : video2;
    const setPhoto = camNumber === 1 ? photo1 : photo2;
    const setIsCameraActive = camNumber === 1 ? isCameraActive1 : isCameraActive2;
    let stream = camNumber === 1 ? stream1 : stream2;
    const currentCameraIndex = camNumber === 1 ? currentCameraIndex1 : currentCameraIndex2;

    try {
        setPhoto.value = null; // Limpiar foto previa
        setIsCameraActive.value = true;

        const constraints = cameras.value.length > 0 && currentCameraIndex.value < cameras.value.length
            ? { video: { deviceId: { exact: cameras.value[currentCameraIndex.value].deviceId } } }
            : { video: { facingMode: 'environment' } };

        stream = await navigator.mediaDevices.getUserMedia(constraints);
        if (video.value) {
            video.value.srcObject = stream;
        }

        if (camNumber === 1) stream1 = stream;
        else stream2 = stream;
    } catch (error) {
        console.error(`Error al iniciar cámara ${camNumber}:`, error);
        alert(`No se pudo iniciar la cámara ${camNumber}. Verifica los permisos o la disponibilidad de la cámara.`);
        setIsCameraActive.value = false;
    }
};

// Cambiar cámara
const changeCamera = async (camNumber: number) => {
    const stream = camNumber === 1 ? stream1 : stream2;
    const currentCameraIndex = camNumber === 1 ? currentCameraIndex1 : currentCameraIndex2;

    if (cameras.value.length <= 1) {
        alert('Solo hay una cámara disponible.');
        return;
    }

    if (stream) {
        stream.getTracks().forEach(track => track.stop());
    }

    currentCameraIndex.value = (currentCameraIndex.value + 1) % cameras.value.length;
    await startCamera(camNumber);
};

// Tomar foto
const takePicture = (camNumber: number) => {
    const video = camNumber === 1 ? video1.value : video2.value;
    const canvas = camNumber === 1 ? canvas1.value : canvas2.value;
    const setPhoto = camNumber === 1 ? photo1 : photo2;
    const setIsCameraActive = camNumber === 1 ? isCameraActive1 : isCameraActive2;
    let stream = camNumber === 1 ? stream1 : stream2;

    if (video && canvas && stream) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        if (context) {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            setPhoto.value = canvas.toDataURL('image/png');
        }

        stream.getTracks().forEach(track => track.stop());
        stream = null;
        setIsCameraActive.value = false;

        if (camNumber === 1) stream1 = null;
        else stream2 = null;
    }
};

// Eliminar foto
const removePhoto = (camNumber: number) => {
    const setPhoto = camNumber === 1 ? photo1 : photo2;
    const setIsCameraActive = camNumber === 1 ? isCameraActive1 : isCameraActive2;
    let stream = camNumber === 1 ? stream1 : stream2;

    setPhoto.value = null;
    setIsCameraActive.value = false;
    if (stream) {
        stream.getTracks().forEach(track => track.stop());
        stream = null;
        if (camNumber === 1) stream1 = null;
        else stream2 = null;
    }
};

// Ajustar tamaño del canvas para la firma
const resizeCanvas = () => {
    const canvas = canvasRef.value;
    if (!canvas) return;
    const ratio = window.devicePixelRatio || 1;
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d')?.scale(ratio, ratio);
};

// Limpiar firma
const limpiarFirma = () => {
    firmaPad.value?.clear();
    firmaBase64.value = null;
};

async function enviarDatos() {
    const result = await question(
        'Se guardaran los datos de entrega del embarque:'+ props.numembarque,
        '¿Deseas guardar los datos?'
    )

    if (!result.isConfirmed) {
        // Usuario canceló, salimos de la función
        return
    }
    console.log(firmaPad.value)
    if (firmaPad.value && !firmaPad.value.isEmpty() && photo1.value && photo1.value.trim() !== "" && photo2.value && photo2.value.trim() !== "") {
        firmaBase64.value = firmaPad.value.toDataURL('image/png')
        const data = {
            matricula: photo1.value,
            cedula: photo2.value,
            firma: firmaBase64.value,
            no_embarque: props.numembarque,
            modificado_por: userStore.globalUser,
            fecha_status: dateTimeStore.formattedDate,
            hora_status: dateTimeStore.formattedTime
        }
        try {
            const response = await fetch(dUrl.urlGlobal + '/api2/guardar-imagenes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            if (response.ok) {
                success('Los archivos fueron guardados correctamente.', 'Guardado exitoso')
            } else {
                error('Ocurrió un error al guardar los archivos.')
            }
        } catch (err: any) {
            error(err.response?.data?.detail || 'Ocurrió un error al guardar los datos.')
        }
        /*await fetch(dUrl.urlGlobal + "/api2/guardar-imagenes/", {
            method: "POST",
            body: formData
        });*/
    } else if (firmaPad.value) {
        warning('No ingreso la firma digital', 'Ingrese la firma')
        return
    } else if (photo1.value == null) {
        warning('Imagen de matricula no capturada', 'Capture imagen de matricula')
    } else if (photo2.value == null) {
        warning('Imagen de cedula no capturada', 'Capture imagen de cedula')
    }
}
// Montar componente
onMounted(() => {
    console.log(dateTimeStore.formattedDate)
    listCameras();

    const carouselElement = carouselRef.value;
    if (carouselElement) {
        const carousel = new Carousel(carouselElement, {
            ride: false, // Desactivar deslizamiento automático
            touch: false
        });

        carouselElement.addEventListener('slid.bs.carousel', (event: any) => {
            const activeIndex = Array.from(carouselElement.querySelectorAll('.carousel-item')).findIndex(
                (item: any) => item.classList.contains('active')
            );

            if (activeIndex === 2 && canvasRef.value) {
                resizeCanvas();
                if (!firmaPad.value) {
                    firmaPad.value = new SignaturePad(canvasRef.value);
                }
            }
        });
    }
});

// Limpiar al desmontar componente
onUnmounted(() => {
    if (stream1) stream1.getTracks().forEach(track => track.stop());
    if (stream2) stream2.getTracks().forEach(track => track.stop());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", { class: "header" }, [
          _hoisted_4,
          _createElementVNode("button", { onClick: handleClick }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              id: "carouselExampleIndicators",
              ref_key: "carouselRef",
              ref: carouselRef,
              class: "carousel carousel-dark slide w-100",
              "data-bs-interval": "false",
              style: {"height":"100%","position":"relative"}
            }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, [
                            (isCameraActive1.value)
                              ? (_openBlock(), _createElementBlock("video", {
                                  key: 0,
                                  ref_key: "video1",
                                  ref: video1,
                                  autoplay: "",
                                  class: "media-box"
                                }, null, 512))
                              : _createCommentVNode("", true),
                            (photo1.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: photo1.value,
                                  alt: "Foto matrícula",
                                  class: "media-box"
                                }, null, 8, _hoisted_16))
                              : _createCommentVNode("", true),
                            _createElementVNode("canvas", {
                              ref_key: "canvas1",
                              ref: canvas1,
                              class: "media-box",
                              style: {"display":"none"}
                            }, null, 512)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (startCamera(1)))
                          }, _hoisted_21),
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeCamera(1)))
                          }, _hoisted_23),
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (takePicture(1)))
                          }, _hoisted_25),
                          _createElementVNode("button", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (removePhoto(1)))
                          }, _hoisted_27)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", null, [
                            (isCameraActive2.value)
                              ? (_openBlock(), _createElementBlock("video", {
                                  key: 0,
                                  ref_key: "video2",
                                  ref: video2,
                                  autoplay: "",
                                  class: "media-box"
                                }, null, 512))
                              : _createCommentVNode("", true),
                            (photo2.value)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: photo2.value,
                                  alt: "Foto cédula",
                                  class: "media-box"
                                }, null, 8, _hoisted_33))
                              : _createCommentVNode("", true),
                            _createElementVNode("canvas", {
                              ref_key: "canvas2",
                              ref: canvas2,
                              class: "media-box",
                              style: {"display":"none"}
                            }, null, 512)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (startCamera(2)))
                          }, _hoisted_38),
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (changeCamera(2)))
                          }, _hoisted_40),
                          _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (takePicture(2)))
                          }, _hoisted_42),
                          _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (removePhoto(2)))
                          }, _hoisted_44)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("canvas", {
                            class: "canvasFirm",
                            ref_key: "canvasRef",
                            ref: canvasRef
                          }, null, 512)
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-auto text-center" }, [
                        _hoisted_50,
                        _createElementVNode("div", { class: "btn-group" }, [
                          _createElementVNode("button", { onClick: enviarDatos }, _hoisted_52),
                          _createElementVNode("button", { onClick: limpiarFirma }, _hoisted_54)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_55
            ], 512)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})